/**
 * Returns value with default unit (pixel) when no unit is given.
 * Does not affect values with given unit.
 */
export default (value: string | number): string => (Number(value) ? `${value}px` : String(value));



// WEBPACK FOOTER //
// ./src/utils/px.ts